var app = angular.module('leonardo');

var ApprovalStepService = function(BaseRestService, $filter) {
  var service = new BaseRestService('approval-steps', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('approval-steps', false, function(step) {
      step.addRestangularMethod('approve', 'post', 'approve');
      step.addRestangularMethod('reject', 'post', 'reject');
      step.addRestangularMethod('requestRevision', 'post', 'request-revision');
      step.addRestangularMethod('returnSubmitter', 'post', 'return-to-submitter');
      step.addRestangularMethod('submitterStatus', 'get', 'submitter-status');
      return step;
    });
  });

  service.STATUS_PENDING = '1';
  service.STATUS_IN_PROGRESS = '2';
  service.STATUS_APPROVED = '3';
  service.STATUS_REJECTED = '4';
  service.STATUS_REVISION_REQUIRED = '5';

  service.STATUS_TYPES = [
    {
      id: service.STATUS_PENDING,
      name: $filter('translate')('Pending')
    },
    {
      id: service.STATUS_IN_PROGRESS,
      name: $filter('translate')('In progress')
    },
    {
      id: service.STATUS_APPROVED,
      name: $filter('translate')('Approved')
    },
    {
      id: service.STATUS_REJECTED,
      name: $filter('translate')('Terminated')
    },
    {
      id: service.STATUS_REVISION_REQUIRED,
      name: $filter('translate')('Request for revision')
    }
  ];
  return service;
};

app.factory('ApprovalStepService', ['BaseRestService', '$filter', ApprovalStepService]);
